/**
 * Copy-to-clipboard core (spec 020 US1). Writes the EXACT value it is given
 * (which may differ from a masked/truncated on-screen form), resolves true on
 * success, and NEVER throws — resolving false when the Clipboard API is missing,
 * runs outside a secure context, or rejects (permission-denied), so the caller
 * can keep the value manually selectable and avoid a false "Copied".
 */
export async function copyText(value: string): Promise<boolean> {
  try {
    const clip = (globalThis as { navigator?: Navigator }).navigator?.clipboard;
    if (!clip?.writeText) return false;
    await clip.writeText(value);
    return true;
  } catch {
    return false;
  }
}
